import { usePropertyContactEmail } from '../../../../../queries/PropertyFields/NonRentalContactFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface OnsitePropertyContactEmailProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const OnsitePropertyContactEmail: React.FC<OnsitePropertyContactEmailProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Email';
    const [onsitePropertyContactEmail, set_onsitePropertyContactEmail] = usePropertyContactEmail(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={`Contact ${label}`}
                    value={onsitePropertyContactEmail}
                />
            ) : (
                <TextBox
                    id='onsitePropertyContactEmail'
                    value={onsitePropertyContactEmail}
                    onChange={(value) => set_onsitePropertyContactEmail(value)}
                    label={label}
                    placeholder='jsmith@gmail.com'
                    required={required}
                    width='100%'
                />
            )}
        </>
    );
};
